import { BubblyButton, ButtonSpinner } from "./custom-button.styles";

function CustomButton({ functions, $loading, children, ...otherProps }) {
  const animateButton = (e) => {
    // React nulls out e.currentTarget once the handler returns, so grab
    // the node now — the setTimeout below runs after that happens.
    const button = e.currentTarget;

    //reset animation
    button.classList.remove("animate");

    button.classList.add("animate");
    setTimeout(function () {
      button.classList.remove("animate");
    }, 700);

    // Props Functions
    if (functions) {
      functions();
    }
  };

  return (
    <BubblyButton
      onClick={animateButton}
      {...otherProps}
      disabled={otherProps.disabled || $loading}
    >
      {$loading ? <ButtonSpinner aria-hidden="true" /> : null}
      {children}
    </BubblyButton>
  );
}

export default CustomButton;
